import { useFormContext } from '@calendly/form'

import { useEventTypeContext } from 'features/event_type_provider'

import { EditingRestricted } from './components/editing_restricted'
import { NameAndColorHeader } from './components/event_details/name_and_color_header'
import { panelComponentsByKey, panelLockNames, PANELS } from './constants'
import { Accordion } from '../components/accordion'
import { useFormHandleSubmit } from '../hooks'

export const Panels = ({
  panelKeys = [],
  etLocks = {},
  lockingDisables = false,
  panelPropsByKey = {},
  submitOnPanelToggle = true
}) => {
  const { eventType, isCreation } = useEventTypeContext()
  const { isSubmitting } = useFormContext()

  const formHandleSubmit = useFormHandleSubmit({ validateOnly: isCreation })

  const { isMETParent } = eventType
  const isEditingRestricted = !isCreation && !isMETParent && Object.values(etLocks).some(Boolean)

  return (
    <>
      <NameAndColorHeader
        isLocked={!isMETParent && etLocks.nameAndColor}
        isMETParent={isMETParent}
        lockingRuleName={panelLockNames[PANELS.nameAndColor]}
      />
      {isEditingRestricted && <EditingRestricted lockingDisables={lockingDisables} fontWeight="standard" />}
      <Accordion disabled={isSubmitting} onPanelToggle={submitOnPanelToggle ? formHandleSubmit : undefined}>
        {panelKeys.map((panelKey) => {
          const PanelComponent = panelComponentsByKey[panelKey]
          if (!PanelComponent) return null

          return (
            <PanelComponent
              key={panelKey}
              panelKey={panelKey}
              isLocked={!isMETParent && etLocks[panelKey]}
              showCannotEditIcon={etLocks[panelKey]}
              showEditingRestricted={!isMETParent && etLocks[panelKey]}
              showLockingRuleSwitch={isMETParent && panelLockNames[panelKey]}
              lockingRuleName={panelLockNames[panelKey]}
              {...panelPropsByKey[panelKey]}
            />
          )
        })}
      </Accordion>
    </>
  )
}
